import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  registeredUsers: drilldownData["registeredUsers"].map(({ fieldName, placeholder, name, formType, validation, className, options, loadOptions }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    options: options,
    loadOptions: loadOptions
  })),
  // newsLetterSubscription:drilldownData["newsLetterSubscription"].map(({ fieldName, placeholder, name, formType, validation, className }: ModuleFields) => ({
  //   name: name,
  //   type: formType,
  //   label: fieldName,
  //   placeholder: placeholder,
  //   validation: validation,
  //   className: className,
  // })), 
};
